module.exports = __webpack_public_path__ + "img/loyalty-reward-title-img.b4497c2c.webp";